import { API } from "aws-amplify";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { IRegistryData } from "../../../../models/RegistryData";
import { APIEndpoints, QueryKeys } from "../../config";

interface IProps {
  registryAbbr: string;
  chartName: string;
}

const makeApiRequest = ({
  registryAbbr,
  chartName,
}: IProps): Promise<IRegistryData> => {
  const qParams = {
    queryStringParameters: {
      registryAbbr: registryAbbr,
      chartType: chartName,
    },
  };
  return API.get(APIEndpoints.public, `/api/v1/public/chart`, qParams);
};

export const useReadPublicChart = ({ registryAbbr, chartName }: IProps) => {
  return useQuery<IRegistryData, AxiosError>(
    QueryKeys.publicStatChart(registryAbbr, chartName),
    () => makeApiRequest({ registryAbbr, chartName }),
    {
      retry: 0,
      enabled: !!registryAbbr,
      staleTime: 60 * 0.25,
    }
  );
};
